import React, { useEffect, useMemo, useState } from "react";
import {
  deleteAssignment,
  fetchAssignments,
  fetchEffectiveRoster,
  fetchStaff,
  fetchTables,
  setDefaultAssignment,
  setOverrideAssignment,
} from "../services/api";
import { useT } from "../i18n/useT";

// AM/OM are machine drafts (2026-06) — pending native review
const STRINGS = {
  en: {
    could_not_load: "Could not load assignments.",
    could_not_set_default: "Could not set default.",
    could_not_set_override: "Could not set override.",
    could_not_remove: "Could not remove.",
    confirm_remove: "Remove {label}?",
    loading: "Loading…",
    heading: "Waiter assignments",
    date_label: "Date",
    today: "today",
    today_btn: "Today",
    intro_a: "Default assignment is who serves a table",
    intro_most_days: "most days",
    intro_b: ". Today's override only applies on",
    intro_c: "; it disappears tomorrow, and the default applies again. The customer's order automatically carries the resolved waiter so ratings attribute correctly.",
    roster_for: "Roster for {when}",
    no_tables_yet: "No tables yet.",
    th_table: "Table",
    th_currently_serving: "Currently serving",
    th_set_override: "Set override for {date}",
    table_label: "Table {n}",
    staff_hash: "staff #{id}",
    override_badge: "override",
    unassigned: "— unassigned —",
    choose_waiter: "(choose waiter)",
    remove_override: "Remove override",
    override_on_table: "override on Table {n} for {date}",
    default_assignments: "Default assignments",
    default_help: "Set who covers each table on a normal day. You only need to touch this when staff change.",
    th_default_waiter: "Default waiter",
    clear_default: "Clear default",
    default_for_table: "default for Table {n}",
  },
  am: {
    could_not_load: "ምደባዎችን መጫን አልተቻለም።",
    could_not_set_default: "ነባሪ ማዘጋጀት አልተቻለም።",
    could_not_set_override: "ሽፍታ ማዘጋጀት አልተቻለም።",
    could_not_remove: "ማስወገድ አልተቻለም።",
    confirm_remove: "{label} አስወግድ?",
    loading: "በመጫን ላይ…",
    heading: "የአስተናጋጅ ምደባዎች",
    date_label: "ቀን",
    today: "ዛሬ",
    today_btn: "ዛሬ",
    intro_a: "ነባሪ ምደባ ማለት አንድን ጠረጴዛ የሚያስተናግደው",
    intro_most_days: "በአብዛኞቹ ቀናት",
    intro_b: " ነው። የዛሬው ሽፍታ የሚሰራው በ",
    intro_c: " ብቻ ነው፤ ነገ ይጠፋል፣ ነባሪውም እንደገና ይሰራል። የደንበኛው ትዕዛዝ የተወሰነውን አስተናጋጅ በራስ-ሰር ይይዛል፤ ስለዚህ ደረጃዎች በትክክል ይመደባሉ።",
    roster_for: "የ{when} ዝርዝር",
    no_tables_yet: "እስካሁን ጠረጴዛ የለም።",
    th_table: "ጠረጴዛ",
    th_currently_serving: "በአሁኑ ጊዜ የሚያስተናግድ",
    th_set_override: "ለ{date} ሽፍታ አዘጋጅ",
    table_label: "ጠረጴዛ {n}",
    staff_hash: "ሠራተኛ #{id}",
    override_badge: "ሽፍታ",
    unassigned: "— ያልተመደበ —",
    choose_waiter: "(አስተናጋጅ ይምረጡ)",
    remove_override: "ሽፍታ አስወግድ",
    override_on_table: "በጠረጴዛ {n} ላይ ለ{date} ሽፍታ",
    default_assignments: "ነባሪ ምደባዎች",
    default_help: "በተለመደ ቀን እያንዳንዱን ጠረጴዛ ማን እንደሚሸፍን ያዘጋጁ። ሠራተኞች ሲቀየሩ ብቻ ይህን መንካት ያስፈልግዎታል።",
    th_default_waiter: "ነባሪ አስተናጋጅ",
    clear_default: "ነባሪ አጽዳ",
    default_for_table: "ለጠረጴዛ {n} ነባሪ",
  },
  om: {
    could_not_load: "Ramaddiiwwan fe'uun hin danda'amne.",
    could_not_set_default: "Durtii qindeessuun hin danda'amne.",
    could_not_set_override: "Bakka bu'iinsa qindeessuun hin danda'amne.",
    could_not_remove: "Balleessuun hin danda'amne.",
    confirm_remove: "{label} balleessuu?",
    loading: "Fe'aat jira…",
    heading: "Ramaddii tajaajilaa",
    date_label: "Guyyaa",
    today: "har'a",
    today_btn: "Har'a",
    intro_a: "Ramaddiin durtii nama minjaala tokko tajaajilu",
    intro_most_days: "guyyoota baay'ee",
    intro_b: " dha. Bakka bu'iinsi har'aa kan hojjetu",
    intro_c: " irratti qofa; bori ni bada, durtiinis ammas ni hojjeta. Ajajni maamilaa tajaajilaa murtaa'e ofumaan waan baatuuf madaalliin sirriitti ramadama.",
    roster_for: "Tarree {when}",
    no_tables_yet: "Minjaalli hin jiru.",
    th_table: "Minjaala",
    th_currently_serving: "Ammaan tana tajaajilaa jiru",
    th_set_override: "Bakka bu'iinsa {date}f qindeessi",
    table_label: "Minjaala {n}",
    staff_hash: "hojjetaa #{id}",
    override_badge: "bakka bu'iinsa",
    unassigned: "— hin ramadamne —",
    choose_waiter: "(tajaajilaa filadhu)",
    remove_override: "Bakka bu'iinsa balleessi",
    override_on_table: "bakka bu'iinsa Minjaala {n} irratti {date}f",
    default_assignments: "Ramaddiiwwan durtii",
    default_help: "Guyyaa idilee keessatti eenyu minjaala tokkoo akka tajaajilu qindeessi. Yommuu hojjettoonni jijjiiraman qofa kana tuquu qabda.",
    th_default_waiter: "Tajaajilaa durtii",
    clear_default: "Durtii haqi",
    default_for_table: "Minjaala {n}f durtii",
  },
};

/**
 * Manager Assignments page.
 *
 * Two panels:
 *   1. "Today's roster" - the effective assignment per table for the chosen
 *      date (defaults to today). Manager can override an individual table
 *      for that day without touching the default.
 *   2. "Default assignments" - the long-running rule: who covers which
 *      tables most days. Override beats default; default beats nothing.
 *
 * The data model lives in backend/app/models/models.py :: TableAssignment.
 */

function todayIso() {
  const d = new Date();
  return d.toISOString().slice(0, 10);
}

export default function ManagerAssignmentsPage() {
  const { lang } = useT();
  const t = (k) => (STRINGS[lang] && STRINGS[lang][k]) || STRINGS.en[k] || k;

  const [tables, setTables] = useState([]);
  const [waiters, setWaiters] = useState([]);
  const [allAssignments, setAllAssignments] = useState([]);
  const [roster, setRoster] = useState([]);
  const [date, setDate] = useState(todayIso());
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busyTable, setBusyTable] = useState(null);

  const loadAll = async () => {
    setLoading(true);
    try {
      const [tb, s, a, r] = await Promise.all([
        fetchTables(),
        fetchStaff(),
        fetchAssignments(),
        fetchEffectiveRoster(date),
      ]);
      setTables(tb);
      // Only waiters are assignable — chef/manager filtered out.
      setWaiters(s.filter((x) => x.role === "waiter" && x.active));
      setAllAssignments(a);
      setRoster(r);
      setError(null);
    } catch (e) {
      setError(toMessage(e, t("could_not_load")));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadAll(); /* eslint-disable-next-line */ }, [date]);

  // Map: tableId -> default assignment row (if one exists)
  const defaultByTable = useMemo(() => {
    const m = {};
    for (const a of allAssignments) {
      if (a.assignment_date === null || a.assignment_date === undefined) {
        m[a.table_id] = a;
      }
    }
    return m;
  }, [allAssignments]);

  // Map: (tableId, date) -> override assignment row
  const overrideByTable = useMemo(() => {
    const m = {};
    for (const a of allAssignments) {
      if (a.assignment_date === date) m[a.table_id] = a;
    }
    return m;
  }, [allAssignments, date]);

  const setDefault = async (tableId, staffId) => {
    if (!staffId) return;
    setBusyTable(`def-${tableId}`);
    try {
      await setDefaultAssignment(tableId, Number(staffId));
      await loadAll();
    } catch (e) {
      setError(toMessage(e, t("could_not_set_default")));
    } finally {
      setBusyTable(null);
    }
  };

  const setOverride = async (tableId, staffId) => {
    if (!staffId) return;
    setBusyTable(`ovr-${tableId}`);
    try {
      await setOverrideAssignment(tableId, Number(staffId), date);
      await loadAll();
    } catch (e) {
      setError(toMessage(e, t("could_not_set_override")));
    } finally {
      setBusyTable(null);
    }
  };

  const removeRow = async (assignmentId, label) => {
    if (!window.confirm(t("confirm_remove").replace("{label}", label))) return;
    try {
      await deleteAssignment(assignmentId);
      await loadAll();
    } catch (e) {
      setError(toMessage(e, t("could_not_remove")));
    }
  };

  if (loading) return <p className="muted">{t("loading")}</p>;

  const isToday = date === todayIso();

  return (
    <>
      <div className="space-between" style={{ marginBottom: 16 }}>
        <h1>{t("heading")}</h1>
        <div>
          <label className="muted" style={{ fontSize: ".85rem" }}>
            {t("date_label")}{" "}
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              style={{ marginLeft: 6 }}
            />
          </label>
          {!isToday && (
            <button
              className="btn secondary small"
              style={{ marginLeft: 8 }}
              onClick={() => setDate(todayIso())}
            >
              {t("today_btn")}
            </button>
          )}
        </div>
      </div>

      {error && <div className="error">{error}</div>}

      <div className="card" style={{ padding: 16, marginBottom: 16 }}>
        <p className="muted" style={{ marginTop: 0 }}>
          {t("intro_a")} <b>{t("intro_most_days")}</b>{t("intro_b")} <b>{date}</b>{t("intro_c")}
        </p>
      </div>

      {/* Today's resolved roster */}
      <div className="card" style={{ marginBottom: 24 }}>
        <h3 style={{ marginTop: 0 }}>
          {t("roster_for").replace("{when}", isToday ? t("today") : date)}
        </h3>
        {tables.length === 0 ? (
          <p className="muted">{t("no_tables_yet")}</p>
        ) : (
          <table className="data" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>{t("th_table")}</th>
                <th>{t("th_currently_serving")}</th>
                <th>{t("th_set_override").replace("{date}", date)}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {tables.map((tbl) => {
                const eff = roster.find((r) => r.table_id === tbl.id);
                const ovr = overrideByTable[tbl.id];
                return (
                  <tr key={tbl.id}>
                    <td><b>{t("table_label").replace("{n}", tbl.table_number)}</b></td>
                    <td>
                      {eff && eff.staff_id ? (
                        <>
                          {eff.staff_name || t("staff_hash").replace("{id}", eff.staff_id)}
                          {eff.is_override && (
                            <span
                              className="tier-badge"
                              style={{
                                background: "#fff8e7",
                                color: "#6c5a00",
                                marginLeft: 8,
                                fontSize: ".7rem",
                              }}
                            >
                              {t("override_badge")}
                            </span>
                          )}
                        </>
                      ) : (
                        <span className="muted">{t("unassigned")}</span>
                      )}
                    </td>
                    <td>
                      <select
                        value={ovr ? ovr.staff_id : ""}
                        onChange={(e) => setOverride(tbl.id, e.target.value)}
                        disabled={busyTable === `ovr-${tbl.id}`}
                      >
                        <option value="">{t("choose_waiter")}</option>
                        {waiters.map((w) => (
                          <option key={w.id} value={w.id}>
                            {w.name || w.email}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {ovr && (
                        <button
                          className="btn danger small"
                          onClick={() =>
                            removeRow(
                              ovr.id,
                              t("override_on_table")
                                .replace("{n}", tbl.table_number)
                                .replace("{date}", date)
                            )
                          }
                        >
                          {t("remove_override")}
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {/* Defaults */}
      <div className="card">
        <h3 style={{ marginTop: 0 }}>{t("default_assignments")}</h3>
        <p className="muted" style={{ marginTop: -4 }}>
          {t("default_help")}
        </p>
        <table className="data" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>{t("th_table")}</th>
              <th>{t("th_default_waiter")}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {tables.map((tbl) => {
              const def = defaultByTable[tbl.id];
              return (
                <tr key={tbl.id}>
                  <td><b>{t("table_label").replace("{n}", tbl.table_number)}</b></td>
                  <td>
                    <select
                      value={def ? def.staff_id : ""}
                      onChange={(e) => setDefault(tbl.id, e.target.value)}
                      disabled={busyTable === `def-${tbl.id}`}
                    >
                      <option value="">{t("choose_waiter")}</option>
                      {waiters.map((w) => (
                        <option key={w.id} value={w.id}>
                          {w.name || w.email}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {def && (
                      <button
                        className="btn danger small"
                        onClick={() =>
                          removeRow(def.id, t("default_for_table").replace("{n}", tbl.table_number))
                        }
                      >
                        {t("clear_default")}
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}

function toMessage(err, fallback) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d?.message) return d.message;
  return fallback;
}
